import React from "react";

export const CallLogIcon: React.FC = () => {
  return (
    <svg
      width="39px"
      height="36px"
      viewBox="0 0 39 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-14.000000, -779.000000)"
        >
          <g
            id="Fluid-MetricsFluid-Metrics-Copy-35"
            transform="translate(14.000000, 779.000000)"
          >
            <g id="call-log-icon" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-215">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#55CDE6"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M12.8202191,9.04998157 C14.015852,9.2193172 14.9316096,10.1372925 15.0340673,11.2691911 C15.094536,11.9372172 14.118058,12.1777749 13.8218381,11.5678267 C13.6092681,11.1301222 13.4243871,10.8365885 13.2896012,10.7014761 C13.1685046,10.5800863 12.8744257,10.3935666 12.4251199,10.1674362 C11.7957487,9.85068096 12.1142066,8.94999012 12.8202191,9.04998157 Z M12.5009279,7.00433989 C14.8802414,7.25305709 16.759186,9.01638145 17.026532,11.2514626 C17.1093238,11.9436233 16.078684,12.1865364 15.8039081,11.5396246 C15.3366605,10.4395715 14.9169336,9.72043501 14.5829387,9.40699234 C14.1865747,9.0350184 13.3838646,8.60736005 12.1910249,8.15159561 C11.5069254,7.89021244 11.7669476,6.9276146 12.5009279,7.00433989 Z M15.2602948,15.0570154 L15.2605105,15.0406373 C15.2652826,14.8685547 15.1322876,14.7203217 14.9595348,14.6967297 C14.4333591,14.6319019 13.9166752,14.5113749 13.4174239,14.3367755 C13.2853064,14.2901184 13.1363684,14.319954 13.0385656,14.4107857 L12.4054452,15.0055998 C12.2030117,15.1957852 11.8902692,15.2354476 11.6414068,15.1024961 C10.2936291,14.3824633 9.17767941,13.3340331 8.4112762,12.0678014 C8.27024537,11.8347939 8.31164954,11.5420614 8.5125558,11.3517422 L9.13976295,10.7575878 C9.2389964,10.663291 9.27075344,10.5233643 9.22037745,10.3974469 C9.03524781,9.93019596 8.9069588,9.44477347 8.83892843,8.95710702 C8.81334063,8.78855576 8.658892,8.66383734 8.47186128,8.66541959 L6.97678467,8.66541917 C6.8753205,8.66553269 6.77857614,8.70569467 6.71017186,8.77609952 C6.64176758,8.84650436 6.60799886,8.94067248 6.61612582,9.02618933 C6.76920842,10.380872 7.25978216,11.6826302 8.05109473,12.8303866 C8.76658466,13.8881869 9.72118099,14.7850262 10.8520174,15.4601893 C12.0635136,16.1982338 13.4423808,16.6590209 14.8662659,16.8044491 C14.9676486,16.8130378 15.0681882,16.781078 15.1431912,16.7164193 C15.2181942,16.6517607 15.2607113,16.5603938 15.2602948,16.4623453 L15.2602948,15.0570154 Z M12.1417676,13.5634385 C12.5952109,13.1422523 13.268074,13.0074629 13.863037,13.2175766 C14.2705064,13.3600751 14.6938224,13.4588222 15.1334923,13.5130478 C15.9526952,13.6246572 16.5535319,14.2943349 16.5321885,15.0561983 L16.5321833,16.459931 C16.5340416,16.8919816 16.3419601,17.3047531 16.0031162,17.5968641 C15.6642723,17.8889752 15.2100605,18.0333612 14.7404697,17.993479 C13.1072556,17.8267863 11.5384261,17.3025179 10.1649388,16.4657583 C8.88143655,15.6994804 7.79323922,14.6771234 6.98060055,13.4756535 C6.08367089,12.1747524 5.52551227,10.6936549 5.3503554,9.14291834 C5.30919198,8.7140037 5.46175028,8.28857669 5.77078296,7.97050597 C6.07981563,7.65243526 6.51688142,7.47099389 6.97602736,7.47048063 L8.46604458,7.47050562 C9.2847222,7.46347033 9.98248082,8.0269156 10.0990521,8.79505966 C10.1555855,9.20006931 10.2606919,9.59777297 10.4116534,9.97879515 C10.6360126,10.5395541 10.4925426,11.1717063 10.0435366,11.5983741 L9.76686631,11.8604648 C10.3152173,12.6429947 11.0275807,13.3124453 11.8603364,13.827836 L12.1417676,13.5634385 Z"
                id="Icon_feather-phone-call"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
